import { FC, useEffect } from "react";
import { YhFormItemsBox } from "@/components/YhFormBox";
import { IYhFormItemsBox, FormItemTypeEnum, IYhFormRef, ISelectOption } from "@/components/YhFormBox/Types";
import { RouterParamType } from "@/model/navModel";
import React from "react";
import { useShipmentDetailModel } from "../shipmentDetailModel";
import useGlobalModel from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { IShipmentTabEnum } from "@/views/shipment/shimentTypes";
import { formatNum } from "@/utils/utils";
import { customerService } from "@/views/base/customer/customerService";
import { DictCodeEnmu } from "@/types/AppDictEnums";

export const BaseFormBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        editFormVal,
        editAmounts,
        tabActive,
        updateFormVal,
        getcurrencySymbol
    } = useShipmentDetailModel(({ editFormVal, editAmounts, tabActive }) => [editFormVal, editAmounts, tabActive]);
    const { fetchCustomerList,isEditable } = useGlobalModel(() => []);
    const { getSelectedDictOne } = useDictModel(() => []);

    //切换到主单的时候去设置下主单的合同金额
    useEffect(() => {
        if (tabActive === IShipmentTabEnum.BASE_DETAIL) {
            let addAmount = +formatNum(editFormVal.addAmount)
            updateFormVal({ ...editFormVal, contractAmount: editAmounts + addAmount });
        }
    }, [tabActive])

    //回显选中客户带出来的数据
    const getCustomer = async (id: string) => {
        let { retData } = await customerService.one(id);
        let data = {
            customerCode: retData.code,
            customerName: retData.name,
            customerId: retData.id,
            phone: retData.phone,
            contact: retData.contact
        }
        console.log(data)
        updateFormVal(data)
    }

    //客户选中
    const customerChange = (value: string, option: ISelectOption) => {
        if (option && option.id) {
            getCustomer(option.id as string)
        }
    }

    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        style: { padding: "10px 0 0 0", marginBottom: "10px" },
        contentClass: "pr-2",
        items: [
            {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: <span>客户名称</span>,
                fieldName: "customerCode",
                onSelectChange: customerChange,
                placeholder: "客户",
                rules: [{ required: true, message: "请选择客户" }],
                selectfetchList: fetchCustomerList,
                defaultQuery: editFormVal.customerName,
                disable: true
                //disable:editFormVal.status == 'shipment.bl'
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                disable: true
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "贸易国别",
                fieldName: "countryCode",
                options: getSelectedDictOne(DictCodeEnmu.COUNTRY),
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "外贸合同号",
                fieldName: "saleRealCode",
                disable: mode === "edit" ? true : false
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "汇率",
                fieldName: "exchangeRate",
                rules: [{ required: true, message: "请输入汇率" }, { pattern: /^[0-9]+(.[0-9]{0,5})?$/, message: '请输入数字且可保留五位小数' }],
                disable: true
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "人民币金额",
            //     fieldName: "rmbAmount",
            //     disable: true
            // },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "合同总金额",
                fieldName: "contractAmount",
                disable: true,
                prefix: getcurrencySymbol(mode),
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "附加费",
                fieldName: "addAmount",
                disable: true,
                prefix: getcurrencySymbol(mode),
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                disable: isEditable
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改人",
                fieldName: "updateUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "币种",
                fieldName: "currencyCode",
                options: getSelectedDictOne(DictCodeEnmu.CURRENCY),
                disable: true
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "修改时间",
                fieldName: "updateTime",
                disable: isEditable
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属部门",
                fieldName: "shopName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "出口商",
                fieldName: "bentityName",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
            },
            //带出
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "国别名称",
                fieldName: "countryName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "货币名称",
                fieldName: "currencyName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "出口商名称",
                fieldName: "bentityCode",
                hidden: true
            },
        ]
    };




    return (
        <YhFormItemsBox {...baseFormItem} />
    )
}